import axiosPrivate from "./axiosPrivate";

const getCobranzas = (params) => {
    return axiosPrivate.get("finanzas-cobranzas", { params })
        .then(response => response.data);
};

const insertCobranza = (data) => {
    return axiosPrivate.post("finanzas-cobranzas", data)
        .then(response => response.data);
};

const updateCobranza = (data) => {
    return axiosPrivate.put("finanzas-cobranzas", data)
        .then(response => response.data);
};

const deleteCobranza = (data) => {
    return axiosPrivate.delete("finanzas-cobranzas", { data })
        .then(response => response.data);
};

export default {
    getCobranzas,
    insertCobranza,
    updateCobranza,
    deleteCobranza
};